{% block sw_extension_card_base_context_menu_actions %}
    {% parent() %}

    <neti-next-incomplete-order-reminder-context-menu-plugin
        v-if="isPluginNetiNextIncompleteOrderReminder"
        :plugin-name="extension?.name"
    ></neti-next-incomplete-order-reminder-context-menu-plugin>
{% endblock %}